/**
 * House of Dusk · fiche encens, upsell a cocher (blocks/_hod-pdp-upsell.liquid).
 * Compte rendu : 00_AI_BRAIN/06_RELEVE_THEME/lots/encens_upsell.md.
 *
 * <hod-pdp-upsell> : case cochee = offre « upsell » posee sur <hod-product> (root.setOffer) :
 *   lignes [variante choisie, variante d'upsell], prix = somme ; le bouton d'ajout et la barre
 *   fixe suivent (libelle « Add to cart · [total] »). Decochee : offre retiree, variante seule.
 *   Aucune ecriture panier ici : hod-cart.js lit data-lines au clic (remarque 29).
 *   Aucun produit d'upsell en vente : le bloc porte un <template> d'apercu, clone seulement avec
 *   ?hod_preview=upsell (root.preview).
 * Limite : <hod-product> sert la PREMIERE offre posee ; le gabarit encens n'a pas de bloc set
 *   (et le set n'est jamais en vente sur le type Incense burner), donc l'upsell est seul.
 */

class HodPdpUpsell extends HTMLElement {
  // Titre et ligne grise en entier sur UNE ligne (Dimi, 14/09/2026) : si le texte deborde,
  // la taille descend par pas de 0,5 px jusqu'a 11 px ; jamais de points de suspension.
  fitText = () => {
    this.querySelectorAll('.hod-up__name, .hod-up__sub').forEach((el) => {
      el.style.fontSize = '';
      let size = parseFloat(getComputedStyle(el).fontSize) || 14;
      while (el.scrollWidth > el.clientWidth + 0.5 && size > 11) {
        size -= 0.5;
        el.style.fontSize = `${size}px`;
      }
    });
  };

  connectedCallback() {
    if (!this.fitObserver && 'ResizeObserver' in window) {
      this.fitObserver = new ResizeObserver(() => this.fitText());
      this.fitObserver.observe(this);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fitText);
    this.fitText();
    this.root = this.closest('hod-product');
    if (!this.root) return;
    if (this.ready) {
      this.subscribe();
      this.apply();
      return;
    }
    customElements.whenDefined('hod-product').then(() => this.init());
  }

  disconnectedCallback() {
    if (this.fitObserver) {
      this.fitObserver.disconnect();
      this.fitObserver = null;
    }
    if (!this.ready) return;
    this.unsubscribe();
    if (this.root.isConnected && typeof this.root.setOffer === 'function') this.root.setOffer(this.offerKey(), null);
  }

  subscribe() {
    this.root.addEventListener('hod:pdp:variant', this.apply);
    this.addEventListener('change', this.onChange);
  }

  unsubscribe() {
    this.root.removeEventListener('hod:pdp:variant', this.apply);
    this.removeEventListener('change', this.onChange);
  }

  init() {
    if (this.ready || !this.isConnected) return;
    const root = this.root;
    if (!root.data || typeof root.setOffer !== 'function') {
      root.addEventListener('hod:pdp:ready', () => this.init(), { once: true });
      return;
    }
    const template = this.querySelector('template[data-hod-up-preview]');
    if (template) {
      if (root.preview !== 'upsell') return;
      this.append(template.content.cloneNode(true));
      template.remove();
      const shell = this.closest('.hod-pdp-b');
      if (shell) shell.hidden = false;
    }
    this.toggle = this.querySelector('input[data-hod-up-toggle]');
    if (!this.toggle) return;
    this.ready = true;
    this.subscribe();
    this.apply();
  }

  onChange = (event) => {
    if (event.target === this.toggle) this.apply();
  };

  // Une cle par carte : plusieurs upsells peuvent etre coches ensemble (offres « addon »).
  offerKey() {
    if (!this.key) {
      const all = this.root ? [...this.root.querySelectorAll('hod-pdp-upsell')] : [];
      this.key = `upsell-${Math.max(0, all.indexOf(this))}`;
    }
    return this.key;
  }

  apply = () => {
    if (!this.ready) return;
    const key = this.offerKey();
    const variant = this.root.variant;
    const id = Number(this.toggle.value);
    if (!this.toggle.checked || !variant || !id) {
      if (this.root.offers && !this.root.offers.has(key)) return;
      this.root.setOffer(key, null);
      return;
    }
    const extra = Number(this.toggle.dataset.price) || 0;
    this.root.setOffer(key, {
      addon: true,
      lines: [{ id, quantity: 1 }],
      price: extra,
      label: '',
      available: true,
    });
  };
}

if (!customElements.get('hod-pdp-upsell')) customElements.define('hod-pdp-upsell', HodPdpUpsell);
